import { FC, useCallback } from 'react';
import { useUpdatedState } from '../utils/hooks';
import './myTowerModal.scss';

const MYTOWER_URL = 'https://mytower.app';
const KOFI_URL = 'https://ko-fi.com/mytower';

// Bump this key's version to re-show the announcement on a future release.
const DISMISS_KEY = 'mytowerAnnounce-28.3';

const FEATURES: readonly string[] = [
  'Share a public profile of your build, perfect for getting help or showing off your progress',
  'Automatically import your progress straight from your save',
  'Automatic farm tracking, with your runs logged for you',
  'Track and calculate all of your upgrades across every domain in one place',
  'Tons of tools, calculators, and optimized paths to push your play further',
];

const MyTowerModal: FC = () => {
  const [dismissed, setDismissed] = useUpdatedState(false, DISMISS_KEY);

  const handleDismiss = useCallback(() => setDismissed(true), [setDismissed]);

  if (dismissed) {
    return null;
  }

  return (
    <div className='mytower-modal-overlay' role='dialog' aria-modal='true'>
      <div className='mytower-modal'>
        <button
          type='button'
          className='mytower-modal__close'
          aria-label='Close'
          onClick={handleDismiss}
        >
          ×
        </button>

        <h2 className='mytower-modal__title'>
          The Tower toolkit is moving to mytower.app
        </h2>

        <p className='mytower-modal__lead'>
          We&apos;ve built a brand new home for everything:{' '}
          <strong>mytower.app</strong>.
        </p>

        <p className='mytower-modal__notice'>
          <strong>Heads up:</strong> this is the{' '}
          <strong>last scheduled content update</strong> for this calculator.
          Going forward, all new data, tools, and updates will live on the new
          app.
        </p>

        <ul className='mytower-modal__features'>
          {FEATURES.map(feature => (
            <li key={feature}>{feature}</li>
          ))}
        </ul>

        <p className='mytower-modal__giveaway'>
          <strong>Launch giveaway:</strong> to celebrate, we&apos;re giving away{' '}
          <strong>in game packs</strong> (details TBD) to players who set up a
          profile and opt in. <strong>No purchase necessary.</strong>
        </p>

        <p className='mytower-modal__support'>
          Love the tools? You can help cover development and hosting costs on
          our Ko-fi.
        </p>

        <div className='mytower-modal__actions'>
          <a
            className='mytower-modal__btn mytower-modal__btn--primary'
            href={MYTOWER_URL}
            target='_blank'
            rel='noopener noreferrer'
            onClick={handleDismiss}
          >
            Check out mytower.app
          </a>
          <a
            className='mytower-modal__btn mytower-modal__btn--kofi'
            href={KOFI_URL}
            target='_blank'
            rel='noopener noreferrer'
            onClick={handleDismiss}
          >
            Support us on Ko-fi
          </a>
          <button
            type='button'
            className='mytower-modal__btn mytower-modal__btn--ghost'
            onClick={handleDismiss}
          >
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
};

export default MyTowerModal;
